import { Types } from "app/forms/elements/types"

export const byName = name => object => {
  if (!object) return
  return object.name === name
}
export const custom = element => element.type === Types.Custom
export const inputs = element => element.type === Types.Input || custom(element)
export const deleted = element => element._delete
export const active = element => !deleted(element)
export const withoutNull = element => element.type !== Types.Null
